import axios from 'axios'
//过滤器，自定义组件，全局方法，实例方法，mixin等在这里添加
export default {
    install (Vue, router) {
        // 请求拦截器
        axios.interceptors.request.use(request => {
            if (request.url.startsWith("/wap/")) {
                request.url = API_SERVER + request.url;
            } else if (!request.url.startsWith("http")) {
                request.url = API_SERVER + "/api" + request.url;
            }
            let token = localStorage.getItem("token")
            request.headers['H5TOKEN'] = token;
            request.timeout = 120000;
            return request
        });
        // 返回拦截器
        axios.interceptors.response.use(response => {
            if (response.status === 401) {
                // router.push("/login")
                // Vue.prototype.$showLogin()
            }
            return response.data
            // return Promise.reject(response);
        }, error => {
            if (error.response && error.response.status === 401) {
                // if(location.href.indexOf("/chat") > 0){
                // 	Vue.prototype.$showLogin()
                // }
            }
            return Promise.reject(error);
        });
        Vue.prototype.$http = axios;
        //loading插件
        // const LoadingConstructor = Vue.extend(LoadingComponent);
        // const LoadingInstance = new LoadingConstructor({
        //     el: document.createElement("div")
        // });
        // document.body.appendChild(LoadingInstance.$el);
        // Vue.prototype.$loading = {
        //     show () {
        //         LoadingInstance.loadingShow = true;
        //     },
        //     hide () {
        //         LoadingInstance.loadingShow = false;
        //     }
        // }
        //
        Vue.prototype.setCache = function(key, value, ttl){
			// ttl 毫秒
			key = "zz_" + key
			if(value){
				const now = new Date().getTime();
				const item = {
					value: value,
					expiry: now + ttl,
				};
				localStorage.setItem(key, JSON.stringify(item));
			}
		};
		Vue.prototype.getCache = function(key){
			key = "zz_" + key
			const itemStr = localStorage.getItem(key);
			if (!itemStr) {
				return null;
			}
			const item = JSON.parse(itemStr);
			const now = new Date().getTime();
			if (now > item.expiry) {
				localStorage.removeItem(key);
				return null;
			}
			return item.value;
		};
		Vue.prototype.clearCache = function(key){
			key = "zz_" + key
			localStorage.removeItem(key);
		}

    }
}